import { render } from "./ModalPresentacion.vue?vue&type=template&id=ed33aeae"
import script from "./ModalPresentacion.vue?vue&type=script&lang=js"
export * from "./ModalPresentacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__